export default __webpack_public_path__ + "static/ProdigySans-Bold-d22d364acfed51e272b5be555520477f.woff2";